Ext.define('SA.data.CallbackSet', {
    add(fn, scope) {
        if (!fn) {
            return;
        }

        var fns = this.fns || (this.fns = []),
            scopes = this.scopes || (this.scopes = []),
            alreadyIncluded = fns.some((existingFn, index) => {
                return existingFn === fn && scopes[index] === scope;
            });

        if (alreadyIncluded) {
            return;
        }

        fns.push(fn);
        scopes.push(scope);
    },

    clear() {
        this.fns = null;
        this.scopes = null;
    },

    destroy() {
        this.clear();
    },

    run(defaultScope, args) {
        var fns = this.fns,
            scopes = this.scopes;

        if (!fns) {
            return;
        }

        this.clear();

        fns.forEach((fn, index) => {
            var scope = scopes[index] || defaultScope;

            if (!scope || !scope.isDestroyed) {
                Ext.callback(fn, scope, args);
            }
        });
    }
});
